import {ref, Ref} from 'vue';
export class EditorNodeInfoStoreControllerClass {
	private static _instance: EditorNodeInfoStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorNodeInfoStoreControllerClass());
	}

	private constructor() {}

	private _shaderExpanded: Ref<boolean> = ref(false);
	// init() {
	// 	this._shaderExpanded
	// }
	shaderExpanded() {
		return this._shaderExpanded;
	}
}

export const EditorNodeInfoStoreController = EditorNodeInfoStoreControllerClass.instance();
